<template>
  <div class="meetings-list">
    <h1>{{title}},{{time}},{{city}}站活动</h1>
    <h2>累计报名人数:{{count}},已通过人数:{{passed}},已拒绝人数：{{rejected}}</h2>
    <div class="excel">
      <el-button @click='getExcel'>
        下载已报名用户数据
      </el-button>
    </div>
    <el-table :data='tableShow' :row-key="getRowKeys">
      <el-table-column prop='id' label='参会人ID' />
      <el-table-column prop='company' label='公司名' />
      <el-table-column prop='stockCode' label='股票代码' />
      <el-table-column prop='person' label='姓名' />
      <el-table-column prop='position' label='职位' />
      <el-table-column prop='phoneNum' label='手机号' />
      <!-- <el-table-column prop='card' label='名片'>
        <template slot-scope='scope'>
          <el-popover ref="scope" width="500" trigger="hover" placement="left-start" offset=12>
            <img :src="scope.row.card" width="100%">
            <el-button slot="reference" type="text">
              <a :href="scope.row.card" target="_blank"> 查看名片</a>
            </el-button>
          </el-popover>
        </template>
      </el-table-column> -->
      
      <!-- <el-table-column prop='sms' label='短信' :filters="[{ text: '已发送', value: 'send' }, { text: '未发送', value: 'notsend' }]" :filter-method="filterSms">
        <template slot-scope='scope'>
          <span v-if='scope.row.sms=="send"' class="need-passed">已发送</span>
          <span v-else class="need-pass"> 未发送 </span>
        </template>
      </el-table-column> -->

      <el-table-column prop='status' label='审核' :filters="[{ text: '待审核', value: '0' }, { text: '已过审', value: '1' }, { text: '已拒审', value:'2' }]"
        :filter-method="filterStatus">
        <template slot-scope='scope'>
          <span v-if='scope.row.status==0' class="need-pass">待审核</span>
          <span v-else-if="scope.row.status==1" class="need-passed">已过审</span>
          <span v-else class="need-failed">已拒审</span>
        </template>
      </el-table-column>
      <el-table-column label='审核操作'>
        <template slot-scope='scope'>
          <span v-if='scope.row.status == 0'>
            <el-button @click="passUser(scope.row)" type="text" size="small">通过</el-button>
            <el-button @click="rejectUser(scope.row)" type="text" size="small">拒绝</el-button>
          </span>

        </template>
      </el-table-column>

      <!-- <el-table-column label='短信操作'>
        <template slot-scope='scope'>
          <el-button @click='rejectSms(scope.row.id,scope.row.phone,scope.row.phoneCode)' type="text" size="small" v-if='scope.row.status == 2 && scope.row.sms=="notsend"'>发送拒绝短信</el-button>
        </template>
      </el-table-column> -->
    </el-table>
  </div>
</template>
<script>
import moment from "moment";
export default {
  data() {
    return {
      tableShow: [],
      tableData: [],
      page: 1,
      count: 0,
      passed: 0,
      rejected: 0,
      city: null,
      title: null,
      time: 0,
      send: 0,
      notsend: 0
    };
  },
  methods: {
    getUserList(acid) {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      this.$http.estateforum_company_info_list({ acid }).then(res => {
        loading.close();
        if (res.data.statusCode === 200) {
          this.tableShow = res.data.result;
          this.count = res.data.result.length;
          this.time = moment(res.data.result.startTime).format(
            "YYYY-MM-DD hh:mm"
          );
          this.passed = res.data.result.filter(
            item => item.status === "1"
          ).length;
          this.rejected = res.data.result.filter(
            item => item.status === "2"
          ).length;
          this.send = res.data.result.filter(
            item => item.sms === "send"
          ).length;
          this.notsend = res.data.result.filter(
            item => item.sms === "notsend"
          ).length;
        } else {
          this.$message.error("请求数据失败," + res.data.message);
        }
      });
    },
    filterSms(value, row) {
      return row.sms == value;
    },
    filterStatus(value, row) {
      return row.status == value;
    },
    passUser(item) {
      item.status = 1;
      this.$http.estateforum_update_company_info({ ...item }).then(res => {
        this.getUserList(this.acid);
      });
    },
    rejectUser(item) {
      item.status = 2;
      this.$http.estateforum_update_company_info({ ...item }).then(res => {
        this.getUserList(this.acid);
      });
    },
    getCityInfo(id) {
      this.$http.estateforum_findbyid({ id }).then(res => {
        if (res.data.statusCode === 200) {
          this.city = res.data.result.city;
          this.title = res.data.result.title;
        }
      });
    },
    getRowKeys(row) {
      return row.id;
    },
    getExcel() {
      console.log("查询数据excel数据");
      window.open(`/acapi//ac/estateforum/getExcel/${this.acid}`);
    }
  },
  computed: {
    acid() {
      return this.$route.params.acid;
    }
  },
  mounted() {
    this.getUserList(this.acid);
    this.getCityInfo(this.acid);
  }
};
</script>

<style scoped>
.need-pass {
  color: #fa5555;
}

.need-passed {
  color: #67c23a;
}

.need-failed {
  color: #878d99;
}

.normal-pagination {
  overflow: hidden;
}

.send-all-user-container {
  float: right;
  padding: 20px 0;
}

.meetings-list h1,
.meetings-list h2 {
  font-size: 16px;
  font-weight: normal;
  padding: 5px;
}
.excel {
  position: absolute;
  top: 20px;
  right: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/backend/estateforum/estateforum_company.vue